import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function getCountdown() {
  const target = new Date('2026-06-11T20:00:00-05:00').getTime();
  const now = Date.now();
  const diff = Math.max(0, target - now);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds, total: diff };
}

export default function HeroSection() {
  const [countdown, setCountdown] = useState(getCountdown());

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(getCountdown());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20football%20soccer%20stadium%20at%20night%20with%20dramatic%20stadium%20lights%20and%20laser%20show%2C%20confetti%20falling%2C%20green%20pitch%20glowing%2C%20massive%20crowd%20celebration%2C%20championship%20atmosphere%2C%20dark%20dramatic%20sky%2C%20cinematic%20lighting%2C%20sports%20photography%2C%20wide%20angle%20epic%20shot%2C%20vibrant%20gold%20and%20green%20color%20palette&width=1920&height=1080&seq=hero-bg-wc2026&orientation=landscape"
          alt="2026世界杯 - 美加墨世界杯"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6 backdrop-blur-sm">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-primary-400 text-xs"></i>
            </span>
            <span className="text-primary-300 text-xs md:text-sm font-medium">
              2026年6月11日 - 7月19日
            </span>
          </div>

          <div className="mb-4">
            <span className="inline-block px-4 py-1.5 bg-accent-500/20 border border-accent-500/30 rounded-full text-accent-300 text-xs font-semibold backdrop-blur-sm">
              第23届国际足联世界杯
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-7xl font-heading font-bold text-background-50 mb-4 leading-tight">
            <span className="block">2026 美加墨</span>
            <span className="block text-primary-400">世界杯</span>
          </h1>

          <p className="text-sm md:text-base text-background-200/90 max-w-2xl mb-10 leading-relaxed">
            48支顶级球队 · 16座主办城市 · 39天巅峰对决 · 104场精彩比赛
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-12">
            {[
              { value: countdown.days, label: '天' },
              { value: countdown.hours, label: '时' },
              { value: countdown.minutes, label: '分' },
              { value: countdown.seconds, label: '秒' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 md:gap-3">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-background-950/60 backdrop-blur-md rounded-lg border border-background-300/20">
                    <span className="font-heading font-bold text-2xl md:text-3xl text-background-50 tabular-nums">
                      {String(item.value).padStart(2, '0')}
                    </span>
                  </div>
                  <span className="text-xs text-background-400 mt-1.5">{item.label}</span>
                </div>
                {i < 3 && (
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-400 mt-[-1.5rem]">
                    :
                  </span>
                )}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
            <a
              href="http://cefotiam.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-vip-crown-line mr-2"></i>
              世界杯投注入口
            </a>
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-300/30 text-background-50 rounded-full text-sm md:text-base font-semibold transition-all duration-200 hover:bg-background-50/25 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-live-line mr-2"></i>
              超清直播
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-300/30 text-background-50 rounded-full text-sm md:text-base font-semibold transition-all duration-200 hover:bg-background-50/25 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              完整赛程
            </Link>
          </div>

          <div className="mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-8">
            {[
              { icon: 'ri-team-line', value: '48', label: '参赛球队' },
              { icon: 'ri-building-line', value: '16', label: '主办城市' },
              { icon: 'ri-football-line', value: '104', label: '比赛场次' },
              { icon: 'ri-global-line', value: '3', label: '联合主办国' },
            ].map((stat, i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 backdrop-blur-sm">
                  <i className={`${stat.icon} text-primary-400 text-lg`}></i>
                </span>
                <div className="text-left">
                  <span className="block font-heading font-bold text-xl md:text-2xl text-background-50">
                    {stat.value}
                  </span>
                  <span className="text-xs text-background-400">{stat.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-400">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}